import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SvyIcon } from '@/components/savory/SvyIcon';
import {
    ProviderCard,
    ProviderCardDescription,
    ProviderCardTitle,
    ProviderCardsGrid,
    ProviderSectionTitle,
} from '../ConfigureZoneModal/ConfigureZoneModal.style';

export const PROVIDER_CONFIG: Record<string, { icon: string; titleId: string; descriptionId: string }> = {
    FISKALTRUST: {
        icon: 'shield-check-line',
        titleId: 'operationZones.configModal.fiskaltrust',
        descriptionId: 'operationZones.configModal.fiskaltrustDescription',
    },
    NF525: {
        icon: 'file-shield-2-line',
        titleId: 'operationZones.configModal.nf525',
        descriptionId: 'operationZones.configModal.nf525Description',
    },
    BOITE_NOIRE: {
        icon: 'database-2-line',
        titleId: 'operationZones.configModal.boiteNoire',
        descriptionId: 'operationZones.configModal.boiteNoireDescription',
    },
    NONE: {
        icon: 'close-circle-line',
        titleId: 'operationZones.configModal.noIntegration',
        descriptionId: 'operationZones.configModal.noIntegrationDescription',
    },
};

type ProviderSelectorProps = {
    availableProviders: string[];
    value: string | null;
    onChange: (provider: string) => void;
    titleId?: string;
    showTitle?: boolean;
};

const ProviderSelector: React.FunctionComponent<ProviderSelectorProps> = ({
    availableProviders,
    value,
    onChange,
    titleId = 'operationZones.configModal.selectProvider',
    showTitle = true,
}) => (
    <>
        {showTitle && (
            <ProviderSectionTitle>
                <FormattedMessage id={titleId} />
            </ProviderSectionTitle>
        )}
        <ProviderCardsGrid>
            {availableProviders.map((provider) => {
                const config = PROVIDER_CONFIG[provider];
                if (!config) return null;
                return (
                    <ProviderCard
                        key={provider}
                        type="button"
                        isSelected={value === provider}
                        onClick={() => onChange(provider)}
                    >
                        <SvyIcon icon={config.icon} />
                        <ProviderCardTitle>
                            <FormattedMessage id={config.titleId} />
                        </ProviderCardTitle>
                        <ProviderCardDescription>
                            <FormattedMessage id={config.descriptionId} />
                        </ProviderCardDescription>
                    </ProviderCard>
                );
            })}
        </ProviderCardsGrid>
    </>
);

export default ProviderSelector;
